import * as React from 'react';
import { SVGProps } from 'react';

const SvgCsv = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg width={25} height={32} viewBox="0 0 25 32" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
    <rect width={24} height={32} rx={3} fill="#C3E2D8" />
    <rect x={5} y={17} width={20} height={10} rx={1} fill="#278E6C" />
    <path
      d="M9.22 25.311c-1.855 0-3.02-1.24-3.02-3.283v-.004c0-2.044 1.169-3.274 3.02-3.274 1.537 0 2.64.971 2.763 2.316l.005.04h-1.292l-.018-.075c-.15-.699-.668-1.156-1.459-1.156-1.015 0-1.665.817-1.665 2.145v.004c0 1.336.65 2.162 1.665 2.162.765 0 1.3-.44 1.472-1.19l.009-.045h1.292l-.004.049c-.123 1.349-1.235 2.311-2.769 2.311ZM15.13 25.311c-1.508 0-2.479-.69-2.554-1.859l-.004-.07h1.253l.008.048c.084.492.607.8 1.332.8.734 0 1.195-.32 1.195-.804v-.005c0-.43-.312-.646-1.098-.808l-.668-.132c-1.253-.25-1.886-.848-1.886-1.802v-.004c0-1.16 1.011-1.925 2.417-1.925 1.468 0 2.369.734 2.43 1.846l.005.083h-1.253l-.004-.052c-.066-.497-.523-.8-1.178-.8-.68.004-1.09.316-1.09.769v.004c0 .4.326.633 1.055.778l.672.136c1.328.264 1.925.804 1.925 1.802v.004c0 1.218-.958 1.991-2.557 1.991ZM20.148 25.201l-2.122-6.341h1.468l1.45 4.983h.026l1.446-4.983h1.472L21.765 25.2h-1.617Z"
      fill="#fff"
    />
  </svg>
);

export default SvgCsv;
